<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div
        class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        "
      >
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link
                class="text-decoration-none router-link"
                to="/AgenteService"
                >หน้าแรก</router-link
              >
            </li>
            <li class="breadcrumb-item" aria-current="page">
              <router-link
                class="text-decoration-none router-link"
                to="/AgenteService"
                >ข้อมูลยื่นคำร้อง</router-link
              >
            </li>
            <li class="breadcrumb-item" aria-current="page">
              <router-link
                class="text-decoration-none router-link"
                to="/AgentInfo"
                >ขอเปลี่ยนแปลงข้อมูลตัวแทน</router-link
              >
            </li>
            <li class="breadcrumb-item router-link active">
              เปลี่ยนแปลงชื่อ - นามสกุล (ภาษาอังกฤษ)
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->

  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile -->
      <div
        class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        "
        style="background-color: #f2f2f2"
      >
        <div class="icon-back">
          <router-link to="/AgentInfo" @click="ClearData()">
            <img src="@/assets/images/arrow-blue.svg" class="w-100" />
          </router-link>
        </div>
        <div
          class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
          style="font-family: DB Heavent; color: #0057a8"
        >
          เปลี่ยนแปลงชื่อ - นามสกุล (ภาษาอังกฤษ)
        </div>
      </div>
      <!-- Mobile -->
      <div class="col">
        <div
          class="title d-none d-lg-block border-bottom font-family blue-1"
        >
          เปลี่ยนแปลงชื่อ - นามสกุล (ภาษาอังกฤษ)
        </div>
        <div class="pb-3 pb-lg-3">
          <div class="mt-4 mt-lg-2">
            <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2 font-family">
              ชื่อ - นามสกุล เดิม
            </div>
          </div>
          <div class="d-lg-flex align-items-center">
            <div class="blue-1 fs-6 mt-1 mt-lg-1" style="font-family: monospace;">
              {{ this.$store.state.AgentInfo.EPRENAME }} {{ this.$store.state.AgentInfo.ENAME }} {{ this.$store.state.AgentInfo.ESURNAME }}
            </div>
          </div>
        </div>
        <div class="row font-family fs-5">
          <div class="col-12 col-md-6 col-lg-6">
            <div class="form-group" style="margin-bottom: 1em">
              <label>คำนำหน้าชื่อ<span class="required">*</span> </label>
              <div class="bg-white form-group">
                <v-select
                  v-model="PreNameEng"
                  class="fs-6"
                  style="font-family: monospace;"
                  :reduce="(option) => option.value"
                  :options="[
                    { id: 1, label: 'MR.', value: 'MR.' },
                    { id: 3, label: 'MRS.', value: 'MRS.' },
                    { id: 2, label: 'MISS.', value: 'MISS.' },
                  ]"
                  placeholder="กรุณาเลือกคำนำหน้าชื่อ"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="field a-field page__field">
                ชื่อ<span class="required">*</span>
                <input
                  v-model="NameEng"
                  type="text"
                  style="font-family: monospace;"
                  class="field__input a-field__input fs-6"
                  @keypress="alphaOnly($event)"
                  maxlength="50"
                />
              </label>
              <span class="text-danger" style="display: inline-block"></span>
            </div>
            <div class="form-group">
              <label class="field a-field page__field">
                นามสกุล<span class="required">*</span>
                <input
                  v-model="SurNameEng"
                  type="text"
                  style="font-family: monospace;"
                  class="field__input a-field__input fs-6"
                  autocomplete="off"
                  @keypress="alphaOnly($event)"
                  maxlength="50"
                />
              </label>
              <span class="text-danger" style="display: inline-block"></span>
            </div>
          </div>
        </div>
        <div class="row mb-3 mt-2">
          <div class="col-6 col-lg-6">
            <button
              type="button"
              class="btn btn-light btn-cancel font-family d-inline-block"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
            >
              ยกเลิก
            </button>
          </div>
          <div class="col-6 col-lg-6 text-right">
            <router-link to="/AgentInfo">
              <button
                type="button"
                class="btn btn-continue font-family d-inline-block"
                @click="EnterNext()"
              >
                ดำเนินการต่อ
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div
    class="modal fade font-family"
    id="exampleModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fs-4" id="exampleModalLabel"></h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="icon-model">
            <img src="@/assets/images/icon-warning.svg" class="w-100" />
          </div>
          <div class="massege fw-normal text-center">
            <p class="mb-0">รายการเปลี่ยนแปลงของท่านยังไม่ได้รับ</p>
            <p class="mb-0">การบันทึก และข้อมูลที่ท่านกรอกจะถูกล้าง</p>
            <p class="mb-0 pt-lg-4">
              ท่านต้องการจะย้อนกลับไปก่อนหน้านี้ใช่หรือไม่
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light fw-normal popup_cancel"
            data-bs-dismiss="modal"
          >
            ไม่ต้องการ
          </button>
          <router-link to="/AgentInfo">
            <button type="button" class="btn btn-model fw-normal" data-bs-dismiss="modal" @click="ClearData()">ต้องการ</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";

export default {
  name: "EditNameEng",
  components: {
    Menu,
  },
  data() {
    return {
      PreNameEng: this.$store.state.EditAgentInfo.CHANGE_ENG.EPRENAME,
      NameEng: this.$store.state.EditAgentInfo.CHANGE_ENG.ENAME,
      SurNameEng: this.$store.state.EditAgentInfo.CHANGE_ENG.ESURNAME,
    };
  },
  mounted() {
    if(this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }
  },
  methods: {
    EnterNext() {
      if(!this.isNullOrEmpty(this.PreNameEng) || !this.isNullOrEmpty(this.NameEng) || !this.isNullOrEmpty(this.SurNameEng)) { 
        this.$store.state.EditAgentInfo.CHANGE_ENG.EPRENAME = this.PreNameEng;
        this.$store.state.EditAgentInfo.CHANGE_ENG.ENAME = this.NameEng;
        this.$store.state.EditAgentInfo.CHANGE_ENG.ESURNAME = this.SurNameEng;
        this.$store.state.EditAgentInfo.CHANGE_ENG.SUCCESS = true;
      }
      else {
        this.$store.state.EditAgentInfo.CHANGE_ENG.EPRENAME = '';
        this.$store.state.EditAgentInfo.CHANGE_ENG.ENAME = '';
        this.$store.state.EditAgentInfo.CHANGE_ENG.ESURNAME = '';
        this.$store.state.EditAgentInfo.CHANGE_ENG.SUCCESS = false;
      }
    },
    ClearData() {
      this.$store.state.EditAgentInfo.CHANGE_ENG.EPRENAME = '';
      this.$store.state.EditAgentInfo.CHANGE_ENG.ENAME = '';
      this.$store.state.EditAgentInfo.CHANGE_ENG.ESURNAME = '';
      this.$store.state.EditAgentInfo.CHANGE_ENG.SUCCESS = false;
      this.PreNameEng = '';
      this.NameEng = '';
      this.SurNameEng = '';
    },
    isNullOrEmpty(value) {
      return ( value == null || value === "" );
    },
    alphaOnly: function(evt) {
      evt = (evt) ? evt : window.event;
      let key = evt.key;
      let re = /[A-Za-z\'\.]/;
      if (re.test(key)) {
        return true;
      } else {
        evt.preventDefault();
      }
    }
  },
};
</script>

<style scoped>
  
</style>